"use client";

// src/separator.tsx
import { cn } from "@momo/utils";
import * as SeparatorPrimitive from "@radix-ui/react-separator";
import { jsx } from "react/jsx-runtime";
var Separator = (props) => {
  const { className, orientation = "horizontal", decorative = true, ...rest } = props;
  return /* @__PURE__ */ jsx(
    SeparatorPrimitive.Root,
    {
      decorative,
      orientation,
      className: cn(
        "bg-border shrink-0",
        orientation === "horizontal" ? "h-px w-full" : "h-full w-px",
        className
      ),
      ...rest
    }
  );
};

export {
  Separator
};
